import { useState, useMemo, useContext, useRef, useEffect } from "react";
import { SocketContext } from "../context/socket";

import axios from "axios";
import _ from "lodash";

export default function useCustomLeaderboard() {
   const socket = useContext(SocketContext);

   const [notification, setNotification] = useState();
   const [all, setAll] = useState();
   const [activeData, setActiveData] = useState();
   const [show, setShow] = useState(true);
   const [runTimestamp, setRunTimestamp] = useState(Date.now());
   const [allPlayers, setAllPlayers] = useState([]);
   const [currentPage, setCurrentPage] = useState(0);
   const maxPage = useRef(0);
   const [playlist, setPlaylist] = useState([]);
   const [playlistIndex, setPlaylistIndex] = useState(null);

   const currentIdRef = useRef();

   useEffect(() => {
      if (activeData && activeData.rows) {
         const totalRows = activeData.rows.length;
         const rowsPerPage = activeData.Rows * activeData.Columns;
         const pagesFrac = totalRows / rowsPerPage;

         if (pagesFrac == 1) {
            maxPage.current = 0;
         } else {
            maxPage.current = Math.floor(pagesFrac);
         }
         setCurrentPage(0);
      }
   }, [activeData]);

   useEffect(() => {
      // console.log(maxPage.current);
   }, [maxPage.current]);

   useEffect(() => {
      // console.log(currentPage);
   }, [currentPage]);

   const handlers = useMemo(
      () => ({
         loadAllPlayers: () => {
            socket.emit("getPlayers", (response) => {
               setAllPlayers(response);
            });
         },
         update: (id, updates) => {
            socket.emit("updateCustomLeaderboard", id, updates, (response) => {
               handlers.get(id);
               handlers.getAll();
            });
         },
         viewerLoad: (viewerId, id) => {
            currentIdRef.current = id;
            socket.emit("customLeaderboardViewerLoad", viewerId, id);
         },
         viewerShowHide: (viewerId, action) => {
            socket.emit("customLeaderboardViewerShowHide", viewerId, action);
         },
         viewerNextPrev: (viewerId, action) => {
            socket.emit(
               "customLeaderboardViewerNextPrev",
               viewerId,
               action,
               currentIdRef.current
            );
         },
         refreshTeams: () => {
            socket.emit("refreshCustomLeaderboardTeams", (response) => {
               handlers.getAll();
            });
         },
         importTeams: () => {
            socket.emit("importCustomLeaderboardTeams", (response) => {
               handlers.getAll();
            });
         },
         get: (id) => {
            socket.emit("getCustomLeaderboard", id, (response) => {
               setActiveData(response);
            });
         },
         getAll: () => {
            socket.emit("getAllCustomLeaderboard", (response) => {
               // console.log(response);
               setAll(response);
            });
         },
         deleteLeaderboard: (id) => {
            socket.emit("deleteCustomLeaderboard", id, (response) => {
               setAll(response);
            });
         },
         add: (callback) => {
            socket.emit("addCustomLeaderboard", (response) => {
               handlers.getAll();
            });
         },
         getPlaylist: () => {
            socket.emit("getCustomLeaderboardPlaylist", (response) => {
               setPlaylist(response);
               // Find current index if there's an active item
               if (currentIdRef.current) {
                  const index = response.findIndex(item => item.id === currentIdRef.current);
                  if (index >= 0) {
                     setPlaylistIndex(index);
                  }
               }
            });
         },
         updatePlaylist: (playlistItems) => {
            socket.emit("updateCustomLeaderboardPlaylist", playlistItems, (response) => {
               setPlaylist(response);
               handlers.getAll();
            });
         },
         playlistNext: () => {
            setPlaylist((currentPlaylist) => {
               setPlaylistIndex((currentIndex) => {
                  if (currentPlaylist.length > 0) {
                     // If no valid index, start at first row (0)
                     if (typeof currentIndex !== "number" || isNaN(currentIndex) || currentIndex < 0) {
                        if (currentPlaylist[0]) {
                           socket.emit("customLeaderboardViewerLoad", 1, currentPlaylist[0].id);
                           currentIdRef.current = currentPlaylist[0].id;
                        }
                        return 0;
                     }
                     // Otherwise, move to next index
                     const nextIndex = (currentIndex + 1) % currentPlaylist.length;
                     if (currentPlaylist[nextIndex]) {
                        socket.emit("customLeaderboardViewerLoad", 1, currentPlaylist[nextIndex].id);
                        currentIdRef.current = currentPlaylist[nextIndex].id;
                     }
                     return nextIndex;
                  }
                  return currentIndex;
               });
               return currentPlaylist;
            });
         },
         playlistPrev: () => {
            setPlaylist((currentPlaylist) => {
               setPlaylistIndex((currentIndex) => {
                  if (currentPlaylist.length > 0) {
                     // If no valid index, start at last row
                     if (typeof currentIndex !== "number" || isNaN(currentIndex) || currentIndex < 0) {
                        const lastIndex = currentPlaylist.length - 1;
                        if (currentPlaylist[lastIndex]) {
                           socket.emit("customLeaderboardViewerLoad", 1, currentPlaylist[lastIndex].id);
                           currentIdRef.current = currentPlaylist[lastIndex].id;
                        }
                        return lastIndex;
                     }
                     // Otherwise, move to previous index
                     const prevIndex = currentIndex === 0 ? currentPlaylist.length - 1 : currentIndex - 1;
                     if (currentPlaylist[prevIndex]) {
                        socket.emit("customLeaderboardViewerLoad", 1, currentPlaylist[prevIndex].id);
                        currentIdRef.current = currentPlaylist[prevIndex].id;
                     }
                     return prevIndex;
                  }
                  return currentIndex;
               });
               return currentPlaylist;
            });
         },
         updatePlaylistIndex: (index) => {
            setPlaylistIndex(index);
         },
         setPage: (viewerId, action) => {
            socket.emit("customLeaderboardSetPage", viewerId, action);
         },
         updatePage: (action) => {
            switch (action) {
               case "next":
                  setCurrentPage((prevState) =>
                     Math.min(maxPage.current, prevState + 1)
                  );
                  break;
               case "prev":
                  setCurrentPage((prevState) => Math.max(prevState - 1, 0));
                  break;
               case "first":
                  setCurrentPage(0);
                  break;
            }
         },
         subscribeViewer: (viewerId) => {
            socket.emit(
               "subscribeCustomLeaderboardViewer",
               viewerId,
               (response) => {
                  // console.log(response);
               }
            );

            socket.on("customLeaderboardViewerLoad", (activeViewerId, id) => {
               if (activeViewerId == viewerId) {
                  handlers.get(id);
                  currentIdRef.current = id;
               }
            });

            socket.on("customLeaderboardViewerData", (data) => {
               // Only set data if this viewer is the one that should receive it
               // Check if the data is meant for this specific viewer
               if (data.targetViewerId == viewerId) {
                  // Remove targetViewerId before setting activeData
                  const { targetViewerId, ...leaderboardData } = data;
                  setActiveData(leaderboardData);
               }
            });

            socket.on("customLeaderboardViewerNextPrev", (activeViewerId, action) => {
               if (activeViewerId == viewerId) {
                  handlers.viewerNextPrev(viewerId, action);
               }
            });

            socket.on("customLeaderboardSetPage", (activeViewerId, action) => {
               if (activeViewerId == viewerId) {
                  handlers.updatePage(action);
               }
            });

            socket.on(
               "customLeaderboardViewerShowHide",
               (activeViewerId, action) => {
                  if (activeViewerId == viewerId) {
                     switch (action) {
                        case "show":
                           setRunTimestamp(Date.now());
                           setShow(true);
                           break;
                        case "hide":
                           setShow((prevState) => {
                              return false;
                           });
                           break;
                        case "toggle":
                           setShow((prevState) => {
                              return !prevState;
                           });
                           break;
                     }
                  }
               }
            );
         },
      }),
      [socket]
   );

   return [
      notification,
      all,
      activeData,
      show,
      runTimestamp,
      allPlayers,
      currentPage,
      playlist,
      playlistIndex,
      handlers,
   ];
}
